import { render, staticRenderFns } from "./BaseCheckboxModal.vue?vue&type=template&id=31a7c334&scoped=true"
import script from "./BaseCheckboxModal.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxModal.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckboxModal.vue?vue&type=style&index=0&id=31a7c334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7c334",
  null
  
)

export default component.exports